<template>
  <div class="clue-block">
    <div class="clue-block__title">{{ name }}</div>
    <div class="clue-block__desc">
      <template v-for="(desc, index) in titleDesc" :key="index">
        <div class="clue-block__desc-item">
          <div class="clue-block__label">{{ desc.key }}</div>
          <template v-if="[0, 1, 2].includes(desc.isRisk)">
            <div class="clue-block__date">
              <div
                class="clue-block__date-prefix"
                :class="{
                  'clue-block__date-prefix--success': desc.isRisk === 0,
                  'clue-block__date-prefix--risk': desc.isRisk === 1,
                  'clue-block__date-prefix--gray': desc.isRisk === 2
                }"
              ></div>
              <div class="clue-block__value">{{ desc.value }}</div>
            </div>
          </template>
          <div
            v-else-if="desc.dataId"
            class="clue-block__value clue-block__value--link"
            @click="emit('openCustomerDetail', desc)"
          >
            {{ desc.value }}
          </div>
          <div v-else class="clue-block__value">{{ desc.value }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  name: String,
  titleDesc: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['openCustomerDetail'])
</script>

<style lang="scss" scoped>
.clue-block {
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;

  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
    color: #323233;
    margin-bottom: 8px;
  }

  &__desc {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
  }

  &__desc-item {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    margin-bottom: 4px;
  }

  &__label {
    color: #969799;
    margin-right: 12px;
    flex: 0 0 84px;
    font-size: 14px;
    line-height: 20px;
  }

  &__value {
    color: #323233;
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;

    &--link {
      cursor: pointer;
      color: #248df5;
    }
  }

  &__date {
    display: flex;
    align-items: center;
    background: #f2f3f5;
    border-radius: 4px;
    padding: 2px 8px;
  }

  &__date-prefix {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    margin-right: 8px;

    &--risk {
      background: #fc5555;
    }

    &--success {
      background: #0fbb54;
    }

    &--gray {
      background: #c9cdcd;
    }
  }
}
</style>
